import { IconCreditCard, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { BIN } from 'typings'
import { Tag, TagItem, TagsList, TagsListTruncate } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

interface Props {
  values: BIN | undefined
  onEdit: () => void
  onRemove: () => void
}

export function BINView(props: Props) {
  const { values, onEdit, onRemove } = props
  const { formatMessage: i18n } = useIntl()

  if (!values) return null

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCreditCard />
      </RuleIcon>

      <RuleDescription>
        {i18n(messages.viewTitle, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          count: values.length,
        })}
      </RuleDescription>

      <RuleContent>
        <TagsListTruncate content={values} lines={7}>
          {values.map((code, index) => (
            <TagsListTruncate.Atom key={index}>
              <Tag key={index}>{code}</Tag>
            </TagsListTruncate.Atom>
          ))}
        </TagsListTruncate>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
